<template>
    <div class="foreign_data_wrap">
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive">
            <div class='option_data_content stock_detail' slot='stock_detail'>
                <div class='main_mid'>
                    <!-- 交易所名称以及相关信息 -->
                    <div class='flex-center exchange_name'>
                        <div>{{ foreign.name }}</div>
                    </div>
                    <!-- 人民币牌价数据 || 人民币汇率中间价 -->
                    <div v-if="foreign.name == '人民币牌价数据' || foreign.name == '人民币汇率中间价'">
                        <div class='foreign_info_text'>{{ foreign.info }}</div>
                        <div class='data_card'>
                            <div class='top_tips'>选择货币
                                <el-checkbox class='ml10' v-model='checkAll' @change='checkAllContract'>全选
                                </el-checkbox>
                            </div>
                            <div v-if="foreign.name == '人民币汇率中间价'" class='money_info'>
                                人式币对马来西亚林吉特、俄罗斯卢布、南非兰特、韩元、阿联酋迪拉姆、沙特里亚尔、匈牙利福林、波兰越罗提、丹麦克朗、瑞典克朗、挪威克朗、土耳其里拉、墨西哥比索、泰铁汇半中间价采取间接标价法，即100人民币折合多少外i币。人民币对其它10种货币汇半中间价仍采取直接标价法，即100外币折合多少人民币。
                            </div>
                            <div>
                                <el-checkbox-group v-model='checkList' class='flex-center filter_item'>
                                    <div class='select-item' :key='item.money' v-for='item in multiChoiceList'>
                                        <div class='country_name'>{{ item.country }}</div>
                                        <el-checkbox :key='item.money' :label='item.money'></el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </div>
                            <div class='top_tips'>选择数据范围<span
                                class='ml10'>{{ foreign.name == '人民币牌价数据' ? '* 请选择2012-01-01之后的日期' : '* 请选择1994-01-01之后的日期' }}</span>
                            </div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='startDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
                                <el-date-picker
                                    v-model='endDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 外汇市场行情 -->
                    <div>
                        <!-- 人民币外汇即期报价 -->
                        <div v-if="foreign.subName == '人民币外汇即期报价' && foreign.name == '外汇市场行情'">
                            <div class='foreign_info_text'>{{ foreign.subInfo }}</div>
                            <div class='data_card'>
                                <div class='top_tips'>数据示例</div>
                                <div>
                                    <el-table :data='spotPriceList' border
                                              :cell-style="{textAlign:'center',padding:'5px 0px'}" stripe
                                              :header-cell-style='$core.table_header'>
                                        <el-table-column type='index' width='80' label='序号'></el-table-column>
                                        <el-table-column prop='currencyPair' label='货币对'></el-table-column>
                                        <el-table-column prop='buy' label='买报价'></el-table-column>
                                        <el-table-column prop='sale' label='卖报价'></el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                        <!-- 人民币外汇远掉报价 -->
                        <div v-if="foreign.subName == '人民币外汇远掉报价' && foreign.name == '外汇市场行情'">
                            <div class='foreign_info_text'>{{ foreign.subInfo }}</div>
                            <div class='data_card'>
                                <div class='top_tips'>数据示例</div>
                                <div>
                                    <el-table :data='forwardPriceList' border
                                              :cell-style="{textAlign:'center',padding:'5px 0px'}" stripe
                                              :header-cell-style='$core.table_header'>
                                        <el-table-column type='index' width='80' label='序号'></el-table-column>
                                        <el-table-column prop='currencyPair' label='货币对'></el-table-column>
                                        <el-table-column prop='week' label='1周'></el-table-column>
                                        <el-table-column prop='January' label='1月'></el-table-column>
                                        <el-table-column prop='Smonth' label='3月'></el-table-column>
                                        <el-table-column prop='June' label='6月'></el-table-column>
                                        <el-table-column prop='September' label='9月'></el-table-column>
                                        <el-table-column prop='year' label='1年'></el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                        <!-- 外汇对即期报价 -->
                        <div v-if="foreign.subName ==  '外币对即期报价' && foreign.name == '外汇市场行情'">
                            <div class='foreign_info_text'>{{ foreign.subInfo }}</div>
                            <div class='data_card'>
                                <div class='top_tips'>数据示例</div>
                                <div>
                                    <el-table :data='foreignCurrencyList' border
                                              :cell-style="{textAlign:'center',padding:'5px 0px'}" stripe
                                              :header-cell-style='$core.table_header'>
                                        <el-table-column type='index' width='80' label='序号'></el-table-column>
                                        <el-table-column prop='currencyPair' label='货币对'></el-table-column>
                                        <el-table-column prop='buy' label='买报价'></el-table-column>
                                        <el-table-column prop='sale' label='卖报价'></el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 货币对-投机情绪报告 -->
                    <div v-if="foreign.name == '货币对-投机情绪报告'">
                        <div class='foreign_info_text'>{{ foreign.info }}</div>
                        <div class='data_card'>
                            <div class='top_tips'>选择数据范围<span
                                class='ml10'>* 请确保选择的时间范围日期必须在当前交易日之前的30个工作日内</span></div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='startDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
                                <el-date-picker
                                    v-model='endDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class='but_btn' style='cursor: pointer'>
                        <div class='donload_btn' @click='queryTheData'>查询数据</div>
                        <div></div>
                    </div>
                </div>
                <!-- 数据预览-->
                <DataPreview
                    v-if='whetherToShowAPreview'
                    ref='dataPreview'
                    :down-load-data='downloadFile'
                    api-url='/ms_resource/fc/preview'
                    :queryParameters='queryParameters'
                ></DataPreview>
            </div>
        </StockData>
    </div>
</template>
<script>
import { foreignMenu } from '../../utils/api';

export default {
    data() {
        return {
            stokeType: '外汇数据',
            menuList: [],
            menuId: '',
            activeIndex: 1,
            checkAll: false,
            checkList: [],
            multiChoiceList: [],
            activeItemIndex: 3,
            startDate: '',
            endDate: '',
                pickerOptions:{
                    disabledDate(data){
                        return data && data.valueOf() >= new Date()
                    }
                },
                spotPriceList:[{
                  currencyPair: "USD/CNY",
                  buy: 6.79,
                  sale: 6.7909
                },
                {
                  currencyPair: "EUR/CNY",
                  buy: 6.8853,
                  sale: 6.8866
                },
                {
                  currencyPair: "100JPY/CNY",
                  buy: 5.0738,
                  sale: 5.0747
                },
                {
                  currencyPair: "HKD/CNY",
                  buy: 0.8658,
                  sale: 0.86593
                },
                {
                  currencyPair: "GBP/CNY",
                  buy: 8.1737,
                  sale: 8.175
                },
                {
                  currencyPair: "AUD/CNY",
                  buy: 4.7603,
                  sale: 4.7611
                },
                {
                  currencyPair: "NZD/CNY",
                  buy: 4.3039,
                  sale: 4.305
                },
                {
                  currencyPair: "SGD/CNY",
                  buy: 4.9222,
                  sale: 4.9232
                },
                {
                  currencyPair: "CHF/CNY",
                  buy: 7.1564,
                  sale: 7.1569
                }],
                forwardPriceList:[
                    {
                      currencyPair: "USD/CNY",
                      week: "-16.60/-16.60",
                      January: "-78.50/-78.20",
                      Smonth: "-267.50/-267.00",
                      June: "-570.00/-570.00",
                      September: "-802.00/-800.00",
                      year: "-995.00/-995.00"
                    },
                    {
                      currencyPair: "EUR/CNY",
                      week: "15.33/15.39",
                      January: "69.39/69.53",
                      Smonth: "195.79/196.90",
                      June: "461.92/464.00",
                      September: "667.27/668.72",
                      year: "914.43/917.44"
                    },
                    {
                      currencyPair: "100JPY/CNY",
                      week: "12.00/12.00",
                      January: "62.21/62.39",
                      Smonth: "204.22/204.27",
                      June: "562.93/563.49",
                      September: "887.56/887.80",
                      year: "1273.25/1275.32"
                    },
                    {
                      currencyPair: "HKD/CNY",
                      week: "-1.15/-1.14",
                      January: "-5.21/-5.04",
                      Smonth: "-19.62/-19.62",
                      June: "-49.33/-49.29",
                      September: "-73.18/-72.52",
                      year: "-93.47/-90.74"
                    },
                    {
                      currencyPair: "GBP/CNY",
                      week: "-9.27/-9.27",
                      January: "-43.57/-43.42",
                      Smonth: "-146.78/-146.78",
                      June: "-296.36/-295.09",
                      September: "-477.03/-475.54",
                      year: "-618.50/-614.05"
                    },
                    {
                      currencyPair: "AUD/CNY",
                      week: "-6.14/-5.94",
                      January: "-32.87/-32.73",
                      Smonth: "-117.95/-117.63",
                      June: "-278.45/-277.53",
                      September: "-436.59/-434.41",
                      year: "-586.26/-579.30"
                    },
                    {
                      currencyPair: "NZD/CNY",
                      week: "-13.00/-13.00",
                      January: "-59.00/-58.24",
                      Smonth: "-181.00/-180.03",
                      June: "-375.00/-374.84",
                      September: "-535.00/-533.67",
                      year: "-679.00/-676.10"
                    },
                    {
                      currencyPair: "SGD/CNY",
                      week: "-9.69/-9.69",
                      January: "-44.86/-44.15",
                      Smonth: "-153.03/-152.47",
                      June: "-295.01/-292.80",
                      September: "-368.09/-364.83",
                      year: "-419.63/-412.17"
                    },
                    {
                      currencyPair: "CHF/CNY",
                      week: "19.43/19.87",
                      January: "91.54/92.03",
                      Smonth: "268.27/273.03",
                      June: "636.92/639.57",
                      September: "917.38/924.47",
                      year: "1260.29/1269.02"
                }],
                foreignCurrencyList:[{
                      currencyPair: "AUD/USD",
                      buy: 0.70109,
                      sale: 0.70109
                    },
                    {
                      currencyPair: "EUR/JPY",
                      buy: 135.699,
                      sale: 135.71
                    },
                    {
                      currencyPair: "EUR/USD",
                      buy: 1.01404,
                      sale: 1.01407
                    },
                    {
                      currencyPair: "GBP/USD",
                      buy: 1.20374,
                      sale: 1.20379
                    },
                    {
                      currencyPair: "USD/CAD",
                      buy: 1.29094,
                      sale: 1.291
                    },
                    {
                      currencyPair: "USD/CHF",
                      buy: 0.94879,
                      sale: 0.94883
                    },
                    {
                      currencyPair: "USD/HKD",
                      buy: 7.84242,
                      sale: 7.84248
                    },
                    {
                      currencyPair: "USD/JPY",
                      buy: 133.822,
                      sale: 133.826
                    },
                    {
                        currencyPair: 'USD/SGD',
                        buy: 1.37936,
                        sale: 1.37937
                    }],
            foreign: {
                name: '人民币牌价数据',
                info: '返回当前交易日指定合约的期权行情数据',
                subName: '人民币外汇即期报价',
                subInfo: '返回指定日期范围内指定货币的人民币汇率中间价数据'
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
        },
        created(){
            this.getMenuList()
        },
        methods: {
            //查询数据
            queryTheData() {
                this.whetherToShowAPreview = true;
                // if(this.checkList.length===0) return this.$message.warning('请选择股票')
                // if(!this.startDate||!this.endDate) return this.$message.warning('请选择时间区间')
                this.queryParameters = {
                    id: this.foreign.name === '外汇市场行情' ? this.activeItemIndex : this.activeIndex,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    monetaryUnit: this.checkList.length > 0 ? this.checkList.join(',') : this.checkList
                };
                setTimeout(() => {
                    this.$refs.dataPreview.queryTheData();
                });
            },

            //下载数据
            downloadFile() {
                let params = {
                    id: this.foreign.name == '外汇市场行情' ? this.activeItemIndex : this.activeIndex,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    monetaryUnit: this.checkList
                };
                let url = this.$core.setObjToUrlParams(this.$config.BASE_URL + '/fc/download', params);
                const loading = this.$loading({
                    lock:true,
                    text:'拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                this.$core.downloadFileData('GET',url).then(res => {loading.close()}).catch(err => {loading.close()})
            },

            //获取外汇目录列表
            getMenuList(){
                foreignMenu().then(res => {
                    this.menuList = res.data
                    this.activeIndex = res.data[0].id
                    this.multiChoiceList = JSON.parse(res.data[0].monetaryUnit).map( item => {
                        let arr = item.split('-')
                        return {
                            country:arr[0],
                            money:arr[1]
                        }
                    })
                }).catch(err => {})
            },

            // 商品期权选择所有合约
            checkAllContract(val){
                this.checkList = val ? this.multiChoiceList.map(item => item.money) : [];
            },

            //目录改变清除时间等缓存数据
            clearCache(){
                this.checkAll = false,
                this.startDate = '',
                this.endDate = '',
                this.checkList = ''
            },

            // el-submenu改变时获取index
            changeActive(index,item){
                this.clearCache();
                this.whetherToShowAPreview = false;
                // 获取多选列表
                if(item.title == '人民币牌价数据' || item.title == '人民币汇率中间价'){
                    this.checkAll = false
                    this.checkList = []
                    this.multiChoiceList = JSON.parse(this.menuList.find(value => value.title == item.title).monetaryUnit).map( item => {
                        let arr = item.split('-')
                        return {
                            country:arr[0],
                            money:arr[1]
                        }
                    })
                }

                this.foreign.name = item.title
                this.foreign.info = item.description
                this.activeIndex = index
            },

            // el-menu-item改变时操作
            changeItemActive(index,item){
                item.title && (this.foreign.subName = item.title)
                item.description && (this.foreign.subInfo = item.description)
                this.activeItemIndex = item.id
            }
        },
    }
</script>
<style lang='scss' scoped>

.foreign_info_text{
    margin: 25px auto 15px 0px;
    color: #999;
}
.top_tips{
    padding-left: 20px;
    font-size: 20px;
    position: relative;
    left: -30px;
    span{
        color: #999;
        font-size: 14px;
    }
}
.download-button{
    margin: 20px auto 0px 90px ;
}
.data_card{
    box-sizing: border-box;
    padding: 40px 120px;
    background: white;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 10px 10px 0px 0px;
    /deep/td{
        border-bottom: 1px solid #e6e6e6;
        padding: 8px 0px !important;
    }
    .money_info{
        color: #b8b8b8;
        line-height: 1.7;
        font-size: 16px;
    }
    .filter_item{
        margin-bottom: 30px;
        flex-wrap: wrap;
        .select-item{
            min-width: 150px;
            font-size: 15px;
            display: flex;
            flex-direction: column;
            .country_name{
                margin: 10px 0px;
                color: #b8b8b8;
            }
        }

        .filter_title{
            color: #666666;
        }
    }
    /deep/.el-checkbox{
        margin-bottom: 15px;
    }
    /deep/.el-radio__label{
        font-size: 18px;
    }
}
.exchange_name{
    font-weight: bold;
    font-size: 24px;
    color: #271B63;
    i{
        font-size: 20px;
    }
}
.notice_text {
    max-width: 800px;
}
.foreign_data_content{
    width: 90%;
}
</style>
